// This file should only contain action type constants.
export const SET_STORED_REQUEST_DATA = 'SET_STORED_REQUEST_DATA';
